__turbopack_context__.v({
  "full": "button-module-scss-module__WBuRGq__full",
  "root": "button-module-scss-module__WBuRGq__root",
  "spin": "button-module-scss-module__WBuRGq__spin",
  "spinner": "button-module-scss-module__WBuRGq__spinner",
});
